import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { isTouchEnabled } from '../../../../Theme';
import { ProductPricesTooltipProps } from '../interfaces/productPricesTooltip.interfaces';
import ProductPricesModal from './ProductPricesModal';
import ProductPricesV2 from './ProductPricesV2';

const ProductPricesTooltip = ({
  prices,
  children,
  closeModal,
  isModalOpen,
  hasPriceVariation,
  open = true,
}: ProductPricesTooltipProps) => {
  if (!open || !prices || prices.length === 0) {
    return children;
  }

  if (isTouchEnabled) {
    return (
      <>
        <ProductPricesModal
          isOpen={isModalOpen}
          onClose={closeModal}
          prices={prices}
          hasPriceVariation={hasPriceVariation}
        />
        {children}
      </>
    );
  }

  return (
    <Tooltip
      TooltipContent={<ProductPricesV2 prices={prices} hasPriceVariation={hasPriceVariation} />}
    >
      {children}
    </Tooltip>
  );
};

export default ProductPricesTooltip;
